/**
 * Japanese and Korean interface text needs fonts that DM Sans does not cover. They are large, so
 * they load only when someone switches to that language. index.css puts them in the body font
 * stack under html[lang='ja'] / html[lang='ko'].
 */
const INTERFACE_FONTS: Record<string, string> = {
  ja: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap',
  ko: 'https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;700&display=swap',
}

export const ensureInterfaceFont = (language: string) => {
  const href = INTERFACE_FONTS[language]
  if (!href || typeof document === 'undefined') return
  const id = `maayot-font-${language}`
  if (document.getElementById(id)) return
  const link = document.createElement('link')
  link.id = id
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}
